import doc                         from 'decorators/doc';
import model                       from 'decorators/model';
import { Timestampable }           from 'helpers/traits';
import { IPartitionNameProps }     from 'modelNames/partition/PartitionName';
import NotificationPrivateApiModel from '../../abstracts/NotificationPrivateApiModel';

@model.cacheDuration()
@model.staticLabel('Statut')
@model.urnResource('notification_status')
@doc.path('/stonecode_notification_notification_statuses/{?id}')
export default class NotificationStatusModel extends Timestampable(NotificationPrivateApiModel) {
	public _filters: ModelFiltersExtended<unknown> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
		'reference': string;
	}> = {};

	@doc.string declare label: string;
	@doc.string declare reference: NotificationNotificationStatusReference;

	public get modelLabel(): string {
		switch (this.reference) {
			case 'pending':
				return 'En attente';
			case 'sent':
				return 'Envoyé';
			case 'scheduled':
				return 'Planifié';
			case 'sending':
				return 'En cours d\'envoi';
			default:
				return this.label;
		}
	}

	public get color() {
		switch (this.reference) {
			case 'pending':
				return 'grey';
			case 'sent':
				return 'green';
			case 'scheduled':
				return 'grey';
			case 'sending':
				return 'blue';
		}
	}

	public renderName(props?: Omit<IPartitionNameProps, 'model'>) {
		return super.renderName(props);
	}
}
